import React, { useEffect, useContext, useState, useRef } from "react";
import { View, Text, TouchableOpacity, TextInput, StatusBar, Modal, ScrollView, FlatList, Platform, Alert, Animated } from "react-native";
import { CredentialsContext } from '../components/CredentialsContext';

import AsyncStorage from "@react-native-async-storage/async-storage";
import NetInfo from "@react-native-community/netinfo";
import { AntDesign, Entypo, Ionicons, MaterialIcons, FontAwesome5, FontAwesome, MaterialCommunityIcons } from '@expo/vector-icons';
import { ListItem, Divider, Switch } from '@rneui/themed';

import axios from "axios";

import BoldStyledText from "../components/BoldStyledText";
import StyledText from "../components/StyledText";
import Card from '../components/Card';
import RadioButton from '../components/RadioButton';

import { EnglishStrings } from '../strings/English';
import { PersianStrings } from '../strings/Persian';
import { ArabicStrings } from '../strings/Arabic';

import envVars from '../env';

const SenariosScreen = props => {
    const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);
    const [senarios, setSenarios] = useState(storedCredentials.senarios)
    const [selectedRoomsHelper, setSelectedRoomsHelper] = useState(0)

    const [senariosSwitch, setSenariosSwitch] = useState(()=> {
        if(storedCredentials.senarios){
            var senariosSwitchesArr = []
            storedCredentials.senarios.forEach(senarioItem => {
                senariosSwitchesArr.push({name: senarioItem.name, value: false})
            });
            return senariosSwitchesArr
        } else {
           const updatedStoredCredentials = {...storedCredentials, ...{senarios: []}}
           AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
           .then(()=> {
               setStoredCredentials(updatedStoredCredentials)  
               setSelectedRoomsHelper(selectedModulesHelper - 1)

               NetInfo.fetch().then(state=> {
                   if(state.isConnected){
                       const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/updateUserInfo';
                       const credentials = {
                           userPhoneNumber: storedCredentials.userPhoneNumber,
                           data: {newSenario: updatedStoredCredentials.senarios} 
                       }
                       axios.post(url, credentials)
                       .catch(err=> {console.log(err);})
                   }
               })
           }).catch(err=> {console.log(err);})

           return []
        }
    })

    const [addSenarioModalVisible, setAddSenarioModalVisible] = useState(false)
    const [senarioName, setSenarioName] = useState('')

    const [selectedRooms, setSelectedRooms] = useState([])

    const [isEdittingMode, setIsEdittingMode] = useState(false)
    const [selectedSenarios, setSelectedSenarios] = useState([])
    const [selectedSenariosHelper, setSelectedSenariosHelper] = useState([])

    const [selectedModules, setSelectedModules] = useState([])
    const [selectedModulesHelper, setSelectedModulesHelper] = useState(0)

    const [isDeletingSenarios ,setIsDeletingSenarios] = useState(false)

    const radioButtonData = [{value: <Ionicons name="sunny-sharp" size={24} color="white" />, mode: 0}, {value: <FontAwesome5 name="snowflake" size={24} color="white" /> , mode: 1}]
   
    const fadeAnim = useRef(new Animated.Value(0)).current;

    const strings = () => {
        if(storedCredentials.language == 'English') {
            return EnglishStrings
        } else if(storedCredentials.language == 'Arabic') {
            return ArabicStrings
        } else return PersianStrings
    }
    
    useEffect(() => {
        // console.log(storedCredentials)
        // console.log(props)
        props.navigation.setOptions({
            headerTitle: () => (
                <View style={{flexDirection: 'row'}}>
                    <BoldStyledText style={{fontSize: 35, color: storedCredentials.theme == 'light' ? 'blue' : '#e88804'}}> {strings().senarios} </BoldStyledText>
                </View>
            ),
            headerTitleAlign: 'center',
            headerTitleStyle:{
                fontSize: 35,
                // fontFamily: "Mikhak-Bold"
            },
            headerStyle:{
                backgroundColor: storedCredentials.theme == "light" ? '#f2f2f2' : '#3b3c37' 
            },
            headerLeft: () => (
                <View style={{justifyContent: 'center'}}>
    
                    <TouchableOpacity 
                        style={{paddingLeft: 17}}
                        onPress={()=>{
                            setAddSenarioModalVisible(true)
                        }}
                    >
                        <Ionicons name="add-circle-outline" size={40} color={storedCredentials.theme == "light" ? 'black' : 'white' } />
    
                    </TouchableOpacity>
                </View>
            ),
            headerTintColor: storedCredentials.theme == "light" ? 'black' : 'white' 
        })
    },[])

    const fetchUserRooms = () =>{
        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/fetchRooms';
        const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);

        const credentials = { 
            userPhoneNumber: storedCredentials.userPhoneNumber,
            userDeviceID: parsedUserDevicesInfo[0].id,
            userDeviceInfo: parsedUserDevicesInfo[0].name,
        };
        
        
        axios.post(url, credentials)
        .then((res)=> {
            const result = res.data;
            const { message, status, data} = result;

            AsyncStorage.getItem('flowerCribCredentials').then((storedData)=> {
                storedData = JSON.parse(storedData);
                storedData.userRooms = data.userRooms;
                var tempStoredData = storedData
                if(data.userInfo.customModulesNames){
                    tempStoredData = {...storedData, ...{customModulesNames: data.userInfo.customModulesNames}, ...{customSwitchesIcons: data.userInfo.customSwitchesIcons}, ...{senarios: data.userInfo.senarios}}
                }
                
                AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(tempStoredData));
                setStoredCredentials(tempStoredData)
                
            })
            .catch((err) => console.log(err))
            
        })
        .catch((err)=> {
        });
    };

    const handleAddNewSenario = () => {

        const index = storedCredentials.senarios.findIndex(senario => senario.name == senarioName)
        if(senarioName == ''){
            if(Platform.OS == 'web'){
                window.alert(strings().pleaseChooseASenarioName)
            } else {
                Alert.alert("",strings().pleaseChooseASenarioName, [{text: strings().ok}])
            }
            return
        } else if(index != -1) {
            if(Platform.OS == 'web'){
                window.alert(strings().thisSenarioNameAlreadyUsed)
            } else {
                Alert.alert("",strings().thisSenarioNameAlreadyUsed, [{text: strings().ok}])
            }
            
            return
        } else {
            var updatedStoredCredentials
            if(storedCredentials.senarios){
                var storedSenarios = storedCredentials.senarios
                const index = storedSenarios.findIndex(senarioItem => senarioItem.name == senarioName)
                if(index == -1){
                    storedSenarios.push({name: senarioName, senario: selectedModules })
                    updatedStoredCredentials = {...storedCredentials, ...{senarios: storedSenarios}}
                } else {
                    if(Platform.OS == 'web'){
                        window.alert(strings().pleaseUseAnUsedName)
                    } else {
                        Alert.alert("",strings().pleaseUseAnUsedName, [{text: strings().ok}])
                    }
                }
            }else {
                updatedStoredCredentials = {...storedCredentials, ...{senarios: [{name: senarioName, senario: selectedModules }]}}
            }

            const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/updateUserInfo';
            const credentials = {
                userPhoneNumber: storedCredentials.userPhoneNumber,
                data: {newSenario: updatedStoredCredentials.senarios} 
            }
            axios.post(url, credentials)
            .then((res)=>{
                const result = res.data;
                const { message, status, data} = result;
    
                AsyncStorage.getItem('flowerCribCredentials').then((storedData)=> {
                    storedData = JSON.parse(storedData);
                    
                    AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials));
                    setSenarios(updatedStoredCredentials.senarios)
                    setSelectedRoomsHelper(selectedModulesHelper - 1)
                    
                })

                handleCancelAddNewSenario()
            })
            .catch((err)=>{
                if(Platform.OS == 'web') {
                    window.confirm(strings().anErrorOccurredPleaseCheckInternetConnection)
                } else {
                    Alert.alert(
                        strings().error,
                        strings().anErrorOccurredPleaseCheckInternetConnection,
                        [{
                            text: strings().ok
                        }]
                    );
                }
            })
            // AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
            // .then(()=> {
            //     setStoredCredentials(updatedStoredCredentials)  
            //     setSelectedRoomsHelper(selectedModulesHelper - 1)

            //     NetInfo.fetch().then(state=> {
            //         if(state.isConnected){
            //             const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/updateUserInfo';
            //             const credentials = {
            //                 userPhoneNumber: storedCredentials.userPhoneNumber,
            //                 data: {newSenario: updatedStoredCredentials.senarios} 
            //             }
            //             axios.post(url, credentials)
            //             .catch(err=> {console.log(err);})
            //         }
            //     })
            // }).catch(err=> {console.log(err);})
            
            // fetchUserRooms()
            handleCancelAddNewSenario()

        }

    }
    
    const handleCancelAddNewSenario = () => {
        setAddSenarioModalVisible(false)
        setSenarioName('')
        setSelectedModules([])
        setSelectedRooms([])
    }

    const roomCheckBoxValueHandler = (roomID) => {
        const index = selectedRooms.findIndex(roomItem => roomItem.id == roomID)
        if(index == -1){
            // console.log(roomID, index)
            return false
        } 
        else {
            // console.log(roomID, index)
            return true
        } 
    }

    const roomCheckBoxValueChangeHandler = (roomID) => {
        const roomIndex = selectedRooms.findIndex(obj => obj.id === roomID);
        if (roomIndex !== -1) {
            // RoomID exists, delete it
            var updatedObjects = selectedRooms
            updatedObjects.splice(roomIndex, 1)
            setSelectedRooms(updatedObjects);
            setSelectedRoomsHelper((selectedRoomsHelper) => selectedRoomsHelper + 1)
            // console.log(selectedRooms)
          } else {
            // RoomID doesn't exist, add a new object
            const newObject = { id: roomID };
            setSelectedRooms(prevObjects => [...prevObjects, newObject]);
            setSelectedRoomsHelper((selectedRoomsHelper) => selectedRoomsHelper + 1)
            // console.log(selectedRooms)
          }

    }

    const moduleCheckboxValueHandler = (module) => {
        const index = selectedModules.findIndex(moduleItem => moduleItem.MAC === module.MAC)
        if(index == -1){
            return [false, '']
        } else {
            return [true, selectedModules[index].state]
        }
    } 

    const moduleCheckboxValueChangeHandler = (module) => {
        const index = selectedModules.findIndex(moduleItem => moduleItem.MAC == module.MAC)
        const inialStateHandler = () => {
            if (module.type[0] == 'S' || module.type == 'P'){
                return '0000'
            } else if (module.type[0] == 'A') {
                return {PWR: '0', FAN: '50', STM: '25', MOD: '0'}
            }
        }
        if(index !== -1) {
            var updatedObjects = selectedModules
            updatedObjects.splice(index, 1)
            setSelectedModules(updatedObjects)
            setSelectedModulesHelper((selectedModulesHelper) => selectedModulesHelper + 1)
            
        } else {
            const newObject = { MAC: module.MAC , state: inialStateHandler()}
            setSelectedModules(prevObjects => [...prevObjects, newObject])
            setSelectedModulesHelper((selectedModulesHelper) => selectedModulesHelper + 1)
            
        }
    }

    const moduleCheckBoxLabelHandler = (module) => {
        if(storedCredentials.customModulesNames) {
            const index = storedCredentials.customModulesNames.findIndex(moduleItem => moduleItem.MAC == module.MAC )
            if(index != -1) {
                return storedCredentials.customModulesNames[index].Name
            } else {
                if( module.type == "P" ){
                    return strings().plug
                } else if ( module.type == "A1") {
                    return strings().AC
                } else if ( module.type == "S1") {
                    return strings().switch
                } else if ( module.type == "S2") {
                    return strings().switch
                } else if ( module.type == "S3") {
                    return strings().switch
                } else if ( module.type == "S4") {
                    return strings().switch
                } else if ( module.type == "A2") {
                    return strings().AC
                }
            }
        } else {
            if( module.type == "P" ){
                return strings().plug
            } else if ( module.type == "A1") {
                return strings().AC
            } else if ( module.type == "S1") {
                return strings().switch
            } else if ( module.type == "S2") {
                return strings().switch
            } else if ( module.type == "S3") {
                return strings().switch
            } else if ( module.type == "S4") {
                return strings().switch
            } else if ( module.type == "A2") {
                return strings().AC
            }

        }
    }

    const moduleCommandHandler = (module, switchNum) => {
        const index = selectedModules.findIndex(moduleItem => moduleItem.MAC == module.MAC)
        var updatedSelectedModules = selectedModules

        if(module.type[0] == 'S' || module.type[0] == 'P'){
            const toggleSwitchState = (num) => {
                if(switchState[num] == 0) {
                    return 1
                } else if(switchState[num] == 1) {
                    return 0
                }
    
            }
            var switchState = [...updatedSelectedModules[index].state]
            switchState[switchNum] = toggleSwitchState(switchNum)
            const command = switchState.toString().replace(/,/g,'');

            updatedSelectedModules[index].state = command

            setSelectedModules(updatedSelectedModules)
            setSelectedModulesHelper((selectedModulesHelper) => selectedModulesHelper + 1)
        } else if(module.type[0] == 'A'){
            
            var moduleState = updatedSelectedModules[index].state
            if(switchNum.MOD){
                moduleState.MOD = switchNum.MOD
            } else if(switchNum.PWR){
                moduleState.PWR = switchNum.PWR
            } else if(switchNum.STM){
                moduleState.STM = switchNum.STM
            } else if(switchNum.FAN){
                if(moduleState.FAN[0] == 0){
                    if(module.type == 'A1'){
                        moduleState.FAN = '2'
                    } else if(module.type == 'A2'){
                        moduleState.FAN = '5'
                    }
                }else{
                    moduleState.FAN = switchNum.FAN
                }

                if(module.type == 'A2') {
                    if(switchNum.FAN == "8" || switchNum.FAN == "0"){
                        moduleState.FAN = '0'
                    } 
                } else if(module.type == 'A1') {
                    if(switchNum.FAN == "4" || switchNum.FAN == "0"){
                        moduleState.FAN = '0'
                    }
                }
            }
            
            updatedSelectedModules[index].state = moduleState
            setSelectedModules(updatedSelectedModules)
            setSelectedModulesHelper((selectedModulesHelper) => selectedModulesHelper + 1)

        }
    }

    const switchesHandler = (module, initState) => {

        if(module.type == 'S1') {   
            return (
                <View style={{flexDirection: 'row', width: '100%', justifyContent: 'space-evenly'}}>
                    <Switch value={initState[1] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 1)} />
                </View> 
            )
        } else if(module.type == 'S2') {
            return (
                <View style={{flexDirection: 'row', width: '100%', justifyContent: 'space-evenly'}}>
                    <Switch value={initState[2] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 2)} />
                    <Switch value={initState[0] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 0)} />
                </View>
            )
        } else if(module.type == 'S3') {
            return (
                <View style={{flexDirection: 'row', width: '100%', justifyContent: 'space-evenly'}}>
                    <Switch value={initState[2] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 2)} />
                    <Switch value={initState[1] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 1)} />
                    <Switch value={initState[0] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 0)} />
                </View>
            )
        } else if(module.type == 'S4') {
            return (
                <View style={{flexDirection: 'row', width: '100%', justifyContent: 'space-evenly'}}>
                    <Switch value={initState[3] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 3)} />
                    <Switch value={initState[2] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 2)} />
                    <Switch value={initState[1] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 1)} />
                    <Switch value={initState[0] == '0' ? false : true} onValueChange={()=> moduleCommandHandler(module, 0)} />
                </View>
            )
        } else if(module.type == 'P') {
            return (
                <View style={{flexDirection: 'row', width: '100%', justifyContent: 'space-evenly'}}>
                    <Switch value={initState[0] == '0' ? false : true} />
                </View>
            )
        } else if(module.type == "A1" || module.type == 'A2'){
            const index = selectedModules.findIndex(moduleItem => moduleItem.MAC == module.MAC)

            return (
                <Card style={{...storedCredentials.theme == 'light' ? LightStyles.loadedACCard : DarkStyles.loadedACCard, ...{width: '100%'}}} activeOpacity = {1}>
                    <View style={{flex: 1, flexDirection: 'column'}}>
                        <View style={{flex: 1}}>
                            <View style={{flex: 1, flexDirection: 'row-reverse', justifyContent: 'center', alignItems: 'center'}}>
                                <View style={{width: '20%'}}>
                                    {selectedModules[index].state.PWR == 1 &&
                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? '#c2ffc2' : '#807f76', borderRadius: 7, flex: 1, width: '100%'}} >
                                            {selectedModules[index].state.MOD == 0 && 
                                                <RadioButton data={radioButtonData} onChange={(mode)=> moduleCommandHandler(module,{MOD: mode.toString()})} initValue={radioButtonData[0].mode}/>
                                            }
                                            {selectedModules[index].state.MOD == 1 && 
                                                <RadioButton data={radioButtonData} onChange={(mode)=> moduleCommandHandler(module,{MOD: mode.toString()})} initValue={radioButtonData[1].mode}/>
                                            }
                                        </View>
                                    }
                                </View>

                                <View style={{flex: 1, alignItems: 'center', width: '60%', marginHorizontal: 15, marginRight: 20}}>
                                   
                                    {selectedModules[index].state.PWR == 1 &&
                                        <View style={{justifyContent: 'center', alignItems: 'center', borderRadius: 7, flex: 1, width: '100%'}}>
                                            <View style={{height: 50, flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'white' : '#6ee391', width: '100%', borderRadius: 7, borderColor: 'white', borderWidth: 2}}>
                                                <TouchableOpacity
                                                    style={{flex: 1,justifyContent: 'center', alignItems: 'center', width:'10%'}}
                                                    onPress={() => moduleCommandHandler(module, {STM: (Number(moduleCheckboxValueHandler(module)[1].STM) + 1).toString()})}
                                                >
                                                    <Entypo name="plus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                </TouchableOpacity>
                                                <View style={{flexDirection: 'row', alignItems: 'center', borderRadius: 10, justifyContent: 'center',paddingRight: 10, width: '50%', marginHorizontal:7 }}>
                                                    <BoldStyledText style={{fontSize: 30, color: storedCredentials.theme == 'light' ? 'black' : 'white', textAlign: 'center', borderRadius: 10, flex: 1}} >
                                                        {selectedModules[index].state.STM}
                                                    </BoldStyledText>
                                                    <MaterialCommunityIcons name="temperature-celsius" size={30} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                </View>
                                                <TouchableOpacity
                                                    style={{flex: 1,justifyContent: 'center', alignItems: 'center', width:'10%'}}
                                                    onPress={() => moduleCommandHandler(module, {STM: (Number(moduleCheckboxValueHandler(module)[1].STM) - 1).toString()})}
                                                >
                                                     <Entypo name="minus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                </TouchableOpacity>
                                            </View> 

                                        </View>
                                    }

                                </View>
                            </View>

                            <View style={{flex: 1, flexDirection: 'row-reverse', justifyContent: 'flex-start', alignItems: 'flex-end'}}>
                                    <View style={{width: '20%'}}>
                                        {selectedModules[index].state.PWR == 0 && 
                                            <View>
                                                <TouchableOpacity
                                                    style={{backgroundColor: '#d30000', padding: 10, borderRadius: 5, alignItems: 'center', height: 50, justifyContent: 'center', borderWidth: 2, borderColor: 'white', width: '100%'}}
                                                    onPress={()=> moduleCommandHandler(module, {PWR: "1"})}
                                                >
                                                    <FontAwesome name="power-off" size={30} color="white" />
                                                </TouchableOpacity>
                                            </View>
                                        }
                                        {selectedModules[index].state.PWR == 1 && 
                                            <View>
                                                <TouchableOpacity
                                                    style={{backgroundColor: '#6ee391', padding: 10, borderRadius: 5, alignItems: 'center', height: 50, justifyContent: 'center', borderWidth: 2, borderColor: 'white', width: '100%'}}
                                                    onPress={()=> moduleCommandHandler(module, {PWR: "0"})}
                                                >
                                                    <FontAwesome name="power-off" size={30} color="white" />
                                                </TouchableOpacity>
                                            </View>
                                        }
                                    </View>

                                    <View style={{flex: 1, alignItems: 'center', width: '60%', marginHorizontal: 15, marginRight: 20}}>
                                        {selectedModules[index].state.PWR == 1 &&
                                            <View style={{height: 50, flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'white' : '#6ee391', width: '100%', borderRadius: 7, borderColor: 'white', borderWidth: 2}}>
                                                <TouchableOpacity
                                                    style={{flex: 1, justifyContent: 'center',alignItems: 'center', margin: 5, width:'10%'}}
                                                    onPress={() => {selectedModules[index].state.FAN[0] == "0" ? moduleCommandHandler(module, {FAN: "1"}) : moduleCommandHandler(module, {FAN: (Number(moduleCheckboxValueHandler(module)[1].FAN[0]) + 1).toString()})}}
                                                >
                                                    <MaterialCommunityIcons name="fan-plus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                </TouchableOpacity>

                                                <View style={{flexDirection: 'row', alignItems: 'center', borderRadius: 10, justifyContent: 'center',paddingRight: 10, width: '50%', marginHorizontal:7}}>
                                                    <BoldStyledText style={{fontSize: 30, color: storedCredentials.theme == 'light' ? 'black' : 'white', textAlign: 'center', marginHorizontal: 10, borderRadius: 10, justifyContent: 'center',alignItems: 'center' ,flex: 1}} >
                                                        {selectedModules[index].state.FAN[0] == 0 ? 'A' : selectedModules[index].state.FAN[0]}
                                                    </BoldStyledText>

                                                    <View>
                                                        {
                                                            selectedModules[index].state.FAN[1] == 0 ?
                                                                <MaterialCommunityIcons name="fan-off" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                            :
                                                                <MaterialCommunityIcons name="fan" size={35} color="blue" />
                                                        }
                                                    </View>

                                                </View>

                                                <TouchableOpacity
                                                    style={{flex: 1, justifyContent: 'center', alignItems: 'center', margin: 5, width:'10%'}}
                                                    onPress={() => {selectedModules[index].state.FAN[0] == "0" ? moduleCommandHandler(module, {FAN: "3"}) : moduleCommandHandler(module, {FAN: (Number(moduleCheckboxValueHandler(module)[1].FAN[0]) - 1).toString()})}}
                                                >
                                                    <MaterialCommunityIcons name="fan-minus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />

                                                </TouchableOpacity>
                                            </View>
                                        }
                                    </View>
                            </View>
                        </View>
                    </View>
                </Card>
            )
        }
    }

    const toggleSelectedItems = (senarioName) => {
        if(!isEdittingMode){
            setIsEdittingMode(true)
        }
        var selectedItemsArr = selectedSenarios
        const index = selectedItemsArr.findIndex(senarioItem => senarioItem == senarioName)
        if(index == -1){
            selectedItemsArr.push(senarioName)
            setSelectedSenarios(selectedItemsArr)
            setSelectedSenariosHelper(selectedSenariosHelper + 1)
        } else {
            selectedItemsArr.splice(index, 1)
            setSelectedSenarios(selectedItemsArr)
            setSelectedSenariosHelper(selectedSenariosHelper - 1)
        }
    }

    const finishDeletingSenariosHandler = () => {
        setIsEdittingMode(false)
        setIsDeletingSenarios(false)
        setSelectedSenarios([])
        setSelectedSenariosHelper(1)

    }

    const deleteSenariosHandler = () => {
        setIsDeletingSenarios(true)
        
        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/updateUserInfo';
        const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);

        var updatedSenarios = storedCredentials.senarios
        selectedSenarios.forEach(senarioName => {
            const index = updatedSenarios.findIndex(senarioItem => senarioItem.name == senarioName)
            updatedSenarios.splice(index, 1)
        })
        var updatedStoredCredentials = storedCredentials
        updatedStoredCredentials.senarios = updatedSenarios

        AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
        .then(()=> {
            setStoredCredentials(updatedStoredCredentials)
            setSelectedRoomsHelper(selectedModulesHelper + 1)

            NetInfo.fetch().then(state=> {
                if(state.isConnected){
                    const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/updateUserInfo';
                    const credentials = {
                        userPhoneNumber: storedCredentials.userPhoneNumber,
                        data: {newSenario: updatedStoredCredentials.senarios} 
                    }
                    axios.post(url, credentials)
                    .catch(err=> {console.log(err);})

                    finishDeletingSenariosHandler()
                }
            })
        }).catch(err=> {console.log(err);})
        

    }

    const onlineModuleCommandHandler = (senario) => {
        var tempToken = '123'
        var moduleIndex
        const roomIndex = storedCredentials.userRooms.findIndex(room => {
            moduleIndex = room.modules.findIndex(module => module.MAC == senario.MAC)
            if(moduleIndex != -1) return true
        })
        if(moduleIndex == -1 || roomIndex == -1) return
        else {
            const moduleItem = storedCredentials.userRooms[roomIndex].modules[moduleIndex]
            var commmandObj
            if(typeof senario.state == 'string'){
                if(moduleItem.orgDID){
                    commmandObj = {
                        CTY: 'mr',
                        STA: senario.state,
                        DID: moduleItem.orgDID,
                        MAC: senario.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        token: tempToken
                    }
                } else {
                    commmandObj = {
                        CTY: 'mr',
                        STA: senario.state,
                        DID: storedCredentials.userPhoneNumber,
                        MAC: senario.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        token: tempToken
                    }
                }
            } else {
                if(moduleItem.orgDID){
                    commmandObj = {
                        CTY: 'mr',
                        DID: moduleItem.orgDID,
                        MAC: senario.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        STM: senario.state.STM,
                        FAN: senario.state.FAN,
                        MOD: senario.state.MOD,
                        PWR: senario.state.PWR,
                        token: tempToken,
                    }
                } else {
                    commmandObj = {
                        CTY: 'mr',
                        DID: storedCredentials.userPhoneNumber,
                        MAC: senario.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        FAN: senario.state.FAN,
                        MOD: senario.state.MOD,
                        PWR: senario.state.PWR,
                        STM: senario.state.STM,
                        token: tempToken
                    }
                }
            }
            
            props.socket.sendMessage(JSON.stringify(commmandObj))
        }
    }

    const offlineModuleCommandHandler = (senario) => {
        var tempToken = '123'
        var moduleIndex
        const roomIndex = storedCredentials.userRooms.findIndex(room => {
            moduleIndex = room.modules.findIndex(module => module.MAC == senario.MAC)
            if(moduleIndex != -1) return true
        })
        if(moduleIndex == -1 || roomIndex == -1) return
        else {
            const moduleItem = storedCredentials.userRooms[roomIndex].modules[moduleIndex]
            var commmandObj
            if(typeof senario.state == 'string'){
                if(moduleItem.orgDID){
                    commmandObj = {
                        CTY: 'mr',
                        STA: senario.state,
                        DID: moduleItem.orgDID,
                        MAC: senario.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        token: tempToken
                    }
                } else {
                    commmandObj = {
                        CTY: 'mr',
                        STA: senario.state,
                        DID: storedCredentials.userPhoneNumber,
                        MAC: senario.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        token: tempToken
                    }
                }
            } else {
                if(moduleItem.orgDID){
                    commmandObj = {
                        CTY: 'mr',
                        DID: moduleItem.orgDID,
                        MAC: senario.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        STM: senario.state.STM,
                        FAN: senario.state.FAN,
                        MOD: senario.state.MOD,
                        PWR: senario.state.PWR,
                        token: tempToken,
                    }
                } else {
                    commmandObj = {
                        CTY: 'mr',
                        DID: storedCredentials.userPhoneNumber,
                        MAC: senario.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        FAN: senario.state.FAN,
                        MOD: senario.state.MOD,
                        PWR: senario.state.PWR,
                        STM: senario.state.STM,
                        token: tempToken
                    }
                }
            }
            
            NetworkInfo.getIPAddress().then(ipAddress => {
                if(ipAddress){
                    const splitedLocalIp = ipAddress.split(".")
                    //console.log("Splited IP: ", splitedLocalIp)
                    const moduleSplitedIp = module.localIp.split(".")
    
                    if( moduleSplitedIp[0] == splitedLocalIp[0] && moduleSplitedIp[1] == splitedLocalIp[1] && moduleSplitedIp[2] == splitedLocalIp[2] ) {
                        const client = TcpSocket.createConnection({port:9999,host: module.localIp, timeout: 2000}, () =>{
                            client.write(JSON.stringify(commmandObj));
                        }) 
    
                        client.on('timeout', ()=> {
                            client.destroy()
                        })
    
                        client.on('data', function(data) {
                            var res = "";
                            data.map(charCode=> res = res + String.fromCharCode(charCode))
                            const parsedData = JSON.parse(res)
                            
                            client.destroy();
                            
                        })        
    
                    }

                }

            });
            
        }
        
    }

    const executeSenarioHandler = (senario) => {
        if(senario.length > 0){
            senario.forEach(senario => {
                NetInfo.fetch().then(state => {
                    if(state.isConnected){
                        onlineModuleCommandHandler(senario)
                    } else {
                        offlineModuleCommandHandler(senario)
                    }
                })
            })

        }
    }

    const senariosSwitchValueHandler = (senarioName) => {
        // console.log(senariosSwitch)
        const index = senariosSwitch.findIndex(senarioItem=> senarioItem.name == senarioName)
        if(index != -1 ) {
            return senariosSwitch[index].value
        } else {
            return false
        }
    }

    return(
        <View style={storedCredentials.theme == 'light' ? LightStyles.wrapper : DarkStyles.wrapper}>
           <StatusBar />
            <Modal
                animationType = 'fade'
                transparent = {true}
                visible = {addSenarioModalVisible}
            >
                <View style={{flex: 1, justifyContent: 'center'}}>
                    <View style={storedCredentials.theme == 'light' ? LightStyles.modalView :  DarkStyles.modalView}>
                        
                        <View style={{...storedCredentials.theme == 'light' ? LightStyles.addModuleModalHeader :  DarkStyles.addModuleModalHeader, ...storedCredentials.language == 'English' && {flexDirection: 'row', paddingLeft: 15}}}>
                            <TouchableOpacity 
                                style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderCloseIconWrapper :  DarkStyles.modalHeaderCloseIconWrapper} 
                                onPress={()=> handleCancelAddNewSenario()}
                                >
                                <AntDesign name="closecircleo" size={28} color="white" />                            
                            </TouchableOpacity>

                            <BoldStyledText style={{...storedCredentials.theme == 'light' ? LightStyles.modalHeaderText :  DarkStyles.modalHeaderText, ...{marginRight: 15}}} > {strings().addSenario} </BoldStyledText>
                        </View>
                        
                        <View style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalBody :  DarkStyles.addModuleModalBody}>
                            <View style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalDescriptionsUSSIDandPassInputsWrapper :  DarkStyles.addModuleModalDescriptionsUSSIDandPassInputsWrapper}>
                                <View style={{justifyContent: 'center', alignItems: 'center' ,flexDirection: storedCredentials.language == 'English' ? 'row-reverse' : 'row'}} > 
                                    <TextInput 
                                        // style={storedCredentials.theme == 'light' ? LightStyles.UssidandPassTextInputs :  DarkStyles.UssidandPassTextInputs} 
                                        style={{...LightStyles.dropdown, ...{flex: 2, alignItems: 'center', height: 50, fontSize: 20}}}
                                        placeholder= {strings().senarioName}
                                        onChangeText={(value) => setSenarioName(value) }    
                                        value={senarioName}
                                    />
                                    <BoldStyledText style={{flex: 1, fontSize: 20}}> {strings().senarioName}: </BoldStyledText>
                                </View>
                                
                                <FlatList
                                    style={{maxHeight: 300, marginTop: 15, borderTopWidth: 3}}
                                    data={storedCredentials.userRooms}
                                    showsVerticalScrollIndicator={false}
                                    keyExtractor={item => item.id}
                                    renderItem=
                                    {roomData =>
                                        <ListItem.Accordion
                                            bottomDivider={true}
                                            icon={<AntDesign name="down" size={18} color="black" />}
                                            content={
                                                <View style={{flex: 1, alignItems: storedCredentials.language == 'English' ?  'flex-start' : 'flex-end'}}>
                                                    <ListItem.Content>
                                                        <ListItem.Title>
                                                            <BoldStyledText style={{fontSize: 19}}>
                                                                { roomData.item.name }
                                                            </BoldStyledText>
                                                        </ListItem.Title>
                                                    </ListItem.Content>

                                                </View>
                                                
                                            }
                                            isExpanded={roomCheckBoxValueHandler(roomData.item.id)}
                                            onPress={()=> {roomCheckBoxValueChangeHandler(roomData.item.id)} }
                                        >
                                            
                                            {roomData.item.modules.map((module, i) => {
                                                return(
                                                
                                                    <ListItem bottomDivider containerStyle={{backgroundColor: 'silver', width: '100%', flexDirection: "row", justifyContent: 'flex-end'}}> 
                                                        {moduleCheckboxValueHandler(module)[0] && 
                                                            <ListItem.Content style={{width: '100%', flex: 3}}>
                                                                {switchesHandler(module ,moduleCheckboxValueHandler(module)[1])}
                                                            </ListItem.Content>    
                                                        }
                                                        
                                                        <ListItem.CheckBox
                                                            containerStyle={{backgroundColor: 'silver', flex: 1}}
                                                            right
                                                            iconRight
                                                            title={moduleCheckBoxLabelHandler(module)}
                                                            textStyle={{fontSize: 18, fontWeight: 'bold'}}
                                                            checkedIcon={<MaterialIcons name="check-box" size={24} color="black" />}
                                                            uncheckedIcon={<MaterialIcons name="check-box-outline-blank" size={24} color="black" />}
                                                            checked={moduleCheckboxValueHandler(module)[0]}
                                                            onPress={()=> {moduleCheckboxValueChangeHandler(module)}}
                                                        />
                                                        
                                                        <Divider color="silver" orientation="vertical" />
                                                    </ListItem>
                                                    
                                                )
                                            }) }
                                            
                                        </ListItem.Accordion>

                                        
                                    }
                                >
                                </FlatList>
                                
                            </View>
                        </View>
                        
                        <TouchableOpacity style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalSubmitBtn :  DarkStyles.addModuleModalSubmitBtn} 
                        onPress={()=> handleAddNewSenario()}
                        >
                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalSubmitBtnText :  DarkStyles.addModuleModalSubmitBtnText}> {strings().addDevice} </StyledText>
                        </TouchableOpacity>
          
                    </View>
                </View>
            </Modal>
            
            {
                isEdittingMode && 
                <View style={{flexDirection: 'row-reverse',justifyContent: 'center', paddingVertical: 10}}>
                    <TouchableOpacity style={{backgroundColor: storedCredentials.theme == 'light' ? 'red' : '#7f7680', padding: 10, marginHorizontal: 7, width: '20%', borderRadius: 15, alignItems: 'center' }}
                        onPress={() => {isDeletingSenarios ? {} : deleteSenariosHandler()}}
                    >
                        <StyledText style={{fontSize: 19, fontWeight: '500', color: 'white'}}> {strings().delete} </StyledText>
                    </TouchableOpacity>
                    <TouchableOpacity style={{backgroundColor: storedCredentials.theme == 'light' ? '#347399' : '#000000' , padding: 10, marginHorizontal: 7, width: '20%', borderRadius: 15, alignItems: 'center'}}
                        onPress={() => {
                            setIsEdittingMode(!isEdittingMode);
                            setSelectedSenarios([]);
                            setSelectedSenariosHelper(1);
                        }}
                        
                    >
                        <StyledText style={{fontSize: 19, fontWeight: '500', color: 'white'}}> {strings().deny} </StyledText>
                    </TouchableOpacity>
                </View>
            }

            <FlatList
                data={senarios}
                showsVerticalScrollIndicator={false}
                keyExtractor={item=> item.name}
                numColumns={2}
                style={{}}
                renderItem=
                {itemData => 
                    <View style={{flex: 1}}>
                        <Card
                            style={{...storedCredentials.theme == 'light' ? LightStyles.s3Card : DarkStyles.s3Card }}
                            // activeOpacity={}
                            onLongPress={()=> isEdittingMode ? {} : toggleSelectedItems(itemData.item.name)}
                            onPress={()=> isEdittingMode ? toggleSelectedItems(itemData.item.name) : executeSenarioHandler(itemData.item.senario)}
                        >
                            <View style={{flexDirection: 'row-reverse', justifyContent: selectedSenarios.findIndex(senarioName => senarioName == itemData.item.name) !== -1 ? 'space-between' : 'center', alignItems: 'center', flex: 1, }}>
                                <View style={{}}>
                                    <StyledText style={storedCredentials.theme == 'light' ? LightStyles.cardTitle : DarkStyles.cardTitle}> {itemData.item.name} </StyledText>
                                </View>

                                {
                                    selectedSenarios.findIndex(senarioName => senarioName == itemData.item.name) !== -1 && 

                                    <View style={{flex: 1}}>
                                        <AntDesign name="checkcircle" size={30} color={storedCredentials.theme == 'light' ? 'blue' : '#f2f2f1'} />
                                    </View>
                                }

                            </View>
                        </Card>
                    </View>
                }
            >
            </FlatList>
        </View>
    )
}

let DarkStyles = {
    wrapper:{
        flex: 1,
        justifyContent: 'space-between',
        backgroundColor: '#3b3c37'
    },
    modalView:{
        marginVertical: 10,
        marginHorizontal: '5%',
        backgroundColor: "white",
        borderRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 50,
        tintColor: 'black',
    },
    addModuleModalHeader:{
        flexDirection: 'row-reverse',
        paddingVertical: 15,
        backgroundColor: '#2b2b28',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: 'center'
    },
    modalHeaderCloseIconWrapper:{
        paddingRight: 15,
        paddingVertical: 10
    },
    modalHeaderText:{
        fontSize: 25,
        fontWeight: '600',
        color: 'white',
    },
    addModuleModalBody:{
        padding: 20,
        backgroundColor: '#b3b2ad',
    },
    addModuleModalDescriptions:{
        fontSize: 18,
        fontWeight: '400',
        margin: 5,
        // textAlign: 'right',
    },
    UssidandPassTextInputs:{
        backgroundColor: '#F5F6FA',
        padding: 10,
        marginHorizontal: 20,
        marginVertical: 10,
        textAlign: 'center',
        borderWidth: 1,
        borderRadius: 20,
        fontSize: 22,
        fontWeight: '300'
    },
    addModuleModalSubmitBtn:{
        backgroundColor: '#807f76',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 15,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20
    },
    addModuleModalSubmitBtnText:{
        color: 'white',
        fontSize: 30,
        fontWeight: '600',
        textAlign: 'center'
    },
    addModuleModalDescriptionsUSSIDandPassInputsWrapper:{
        margin: 10,
        marginBottom: 50
    },
    loadedACCard:{
        justifyContent: 'center',
        height: 250,
        backgroundColor: '#807f76',
    },
    s3Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#1c1c1a',
        
    },
    cardTitle:{
        fontSize: 30,
        textAlign: 'right',
        color: 'white'
    },
}



let LightStyles = {
    wrapper:{
        flex: 1,
        justifyContent: 'space-between',
    },
    modalView:{
        marginVertical: 10,
        marginHorizontal: '5%',
        backgroundColor: "white",
        borderRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 50,
        tintColor: 'black',
    },
    addModuleModalHeader:{
        flexDirection: 'row-reverse',
        paddingVertical: 15,
        backgroundColor: '#344a47',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: 'center'
    },
    modalHeaderCloseIconWrapper:{
        paddingRight: 15,
        paddingVertical: 10
    },
    modalHeaderText:{
        fontSize: 25,
        fontWeight: '600',
        color: 'white',
    },
    addModuleModalBody:{
        padding: 20,
    },
    addModuleModalDescriptions:{
        fontSize: 18,
        fontWeight: '400',
        margin: 5,
        // textAlign: 'right',
    },
    UssidandPassTextInputs:{
        backgroundColor: '#F5F6FA',
        padding: 10,
        marginHorizontal: 20,
        marginVertical: 10,
        textAlign: 'center',
        borderWidth: 1,
        borderRadius: 20,
        fontSize: 22,
        fontWeight: '300'
    },
    addModuleModalSubmitBtn:{
        backgroundColor: '#dab2be',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 15,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20
    },
    addModuleModalSubmitBtnText:{
        color: 'white',
        fontSize: 30,
        fontWeight: '600',
        textAlign: 'center'
    },
    addModuleModalDescriptionsUSSIDandPassInputsWrapper:{
        margin: 10,
        marginBottom: 50
    },
    dropdown: {
        borderColor: 'black',
        borderWidth: 0.5,
        borderRadius: 8,
    },
    loadedACCard:{
        justifyContent: 'center',
        height: 225,
        backgroundColor: '#c2ffc2',
    },
    s3Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#88b388',
        
    },
    cardTitle:{
        fontSize: 30,
        textAlign: 'right',
        color: 'black'
    },
}
export default SenariosScreen